// extracted by mini-css-extract-plugin
export default {"alternate":"Section-module--alternate--3f453","bgUp":"Section-module--bgUp--fc9d3","bgDown":"Section-module--bgDown--5fce0","content":"Section-module--content--42444"};